export default {
  IMPERSONATED_COMPANY_ID: 'IMPERSONATED_COMPANY_ID',
  JWT_REFRESH_EXPIRATION: 'JWT_REFRESH_EXPIRATION',
  IMPERSONATED_TEAMS_COMPANY_ID: 'IMPERSONATED_TEAMS_COMPANY_ID',
};
